export const TagItem = ({ nomeTag, corHex }) => {
    const bgColor = corHex ? `bg-${corHex}-50` : 'bg-gray-100';
    const textColor = corHex ? `text-${corHex}-700` : 'text-gray-600';
    const borderColor = corHex ? `border-${corHex}-200` : 'border-gray-200';
    const dotColor = corHex ? `bg-${corHex}-400` : 'bg-gray-400';

    return (
        <div
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border ${bgColor} ${textColor} ${borderColor} max-w-[90px]`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${dotColor} shrink-0`} />
            <span className="text-[10px] font-medium truncate leading-tight">
                {nomeTag}
            </span>
        </div>
    );
};
